import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Notification from './components/Notification';
import Home from './pages/Home';
import Shows from './pages/Shows';
import Contact from './pages/Contact';
import './style.css';
import './contact.css';
import './shows.css';

function App() {
  const [notification, setNotification] = useState(null);

  const showNotification = (message, type = 'info') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  return (
    <Router>
      <div className="App">
        <Navbar />
        {notification && <Notification message={notification.message} type={notification.type} />}
        <Routes>
          <Route path="/" element={<Home showNotification={showNotification} />} />
          <Route path="/shows" element={<Shows showNotification={showNotification} />} />
          <Route path="/contact" element={<Contact showNotification={showNotification} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
